var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFeatherUsers = function SvgIconFeatherUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.753,
    height: 25.869,
    viewBox: "0 0 30.753 25.869",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1.661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.684,30.069V27.546A5.046,5.046,0,0,0,16.638,22.5H6.546A5.046,5.046,0,0,0,1.5,27.546v2.523",
    transform: "translate(-1.5 -7.362)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.592,9.546A5.046,5.046,0,1,1,12.546,4.5a5.046,5.046,0,0,1,5.046,5.046Z",
    transform: "translate(-2.454 -4.5)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.785,30.1V27.577A5.046,5.046,0,0,0,30,22.7",
    transform: "translate(-6.031 -7.393)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,4.7a5.046,5.046,0,0,1,0,9.777",
    transform: "translate(-5.077 -4.531)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFeatherUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-feather-users.c0ef8aee.svg";
export { ForwardRef as ReactComponent };